import { useSortable } from "@dnd-kit/sortable";
import {
  faArrowDown,
  faArrowUp,
  faClone,
  faTrashCan,
} from "@fortawesome/pro-regular-svg-icons";

import {
  ContextMenu,
  ContextMenuProps,
} from "src/decisionTableNode/ContextMenu";
import { MatrixTableActions } from "src/matrixTableNode/utils";

export const RowContextMenu = ({
  show,
  index,
  actions,
  rowId,
}: {
  show: boolean;
  index: number;
  actions: MatrixTableActions;
  rowId: string;
}) => {
  const { attributes, listeners, active } = useSortable({
    id: rowId,
  });
  const buttonProps = {
    ...attributes,
    ...listeners,
  } as ContextMenuProps["buttonProps"];

  const isActive = rowId === active?.id;

  return (
    <ContextMenu
      button="vertical"
      buttonProps={buttonProps}
      hide={isActive} // Hide the menu icon when the row is being dragged
      show={show}
    >
      <ContextMenu.Item
        icon={faArrowUp}
        onClick={() => actions.insertRow(index)}
      >
        Insert Above
      </ContextMenu.Item>
      <ContextMenu.Item
        icon={faArrowDown}
        onClick={() => actions.insertRow(index + 1)}
      >
        Insert Below
      </ContextMenu.Item>
      <ContextMenu.Item
        icon={faClone}
        onClick={() => actions.insertRow(index, true)}
      >
        Duplicate
      </ContextMenu.Item>
      <ContextMenu.Item
        icon={faTrashCan}
        onClick={() => actions.deleteRow(index)}
      >
        Delete row
      </ContextMenu.Item>
    </ContextMenu>
  );
};
